import { InformationalModal } from 'component/modal/informational-modal';
import React from 'react';
import { t } from 'util/stdtypes';

export type ModerationAdminBypassModalProps = {
    onClose: () => void;
    children: React.ReactNode;
};

export function ModerationAdminBypassModal({ onClose, children }: ModerationAdminBypassModalProps) {
    return (
        <InformationalModal
            content={children}
            headingLabel={t('moderation.admin_bypass_flag', 'You bypassed an AI flag')}
            onClose={onClose}
            subheadingLabel={t(
                'moderation.admin_bypassed',
                '⚠️ AI flagged your response, but you automatically bypassed it as an Admin user.',
            )}
        />
    );
}
